import _asyncToGenerator from "E:/dayinjia/Vue/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/web.dom-collections.for-each.js";
import "core-js/modules/es.array.slice.js";
import "core-js/modules/es.function.name.js";
import "core-js/modules/es.array.concat.js";
import "core-js/modules/es.array.splice.js";
import "regenerator-runtime/runtime.js";
import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, unref as _unref, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";

var _withScopeId = function _withScopeId(n) {
  return _pushScopeId("data-v-32712e7c"), n = n(), _popScopeId(), n;
};

var _hoisted_1 = {
  class: "navbar"
};
var _hoisted_2 = {
  class: "iconContainer"
};

var _hoisted_3 = /*#__PURE__*/_withScopeId(function () {
  return /*#__PURE__*/_createElementVNode("span", {
    class: "text"
  }, "折叠", -1);
});

var _hoisted_4 = {
  class: "iconContainer"
};

var _hoisted_5 = /*#__PURE__*/_withScopeId(function () {
  return /*#__PURE__*/_createElementVNode("span", {
    class: "text"
  }, "展开", -1);
});

var _hoisted_6 = {
  class: "iconContainer"
};

var _hoisted_7 = /*#__PURE__*/_withScopeId(function () {
  return /*#__PURE__*/_createElementVNode("span", {
    class: "text"
  }, "调整世系", -1);
});

var _hoisted_8 = /*#__PURE__*/_withScopeId(function () {
  return /*#__PURE__*/_createElementVNode("span", {
    class: "text"
  }, "删除", -1);
});

var _hoisted_9 = {
  class: "el-dropdown-link text"
};

var _hoisted_10 = /*#__PURE__*/_createTextVNode(" 更多功能 ");

var _hoisted_11 = /*#__PURE__*/_createTextVNode("回收站");

var _hoisted_12 = /*#__PURE__*/_createTextVNode("调整姓氏");

var _hoisted_13 = /*#__PURE__*/_createTextVNode("设置避名号");

var _hoisted_14 = /*#__PURE__*/_createTextVNode("在世/已故设置");

var _hoisted_15 = /*#__PURE__*/_createTextVNode("设置");

var _hoisted_16 = {
  class: "navbar-right"
};

var _hoisted_17 = /*#__PURE__*/_withScopeId(function () {
  return /*#__PURE__*/_createElementVNode("span", {
    class: "text"
  }, "保存", -1);
});

var _hoisted_18 = {
  class: "iconContainer"
};

var _hoisted_19 = /*#__PURE__*/_withScopeId(function () {
  return /*#__PURE__*/_createElementVNode("span", {
    class: "text"
  }, "手机预览", -1);
});

var _hoisted_20 = {
  class: "iconContainer"
};

var _hoisted_21 = /*#__PURE__*/_withScopeId(function () {
  return /*#__PURE__*/_createElementVNode("span", {
    class: "text"
  }, "排版预览", -1);
});

var _hoisted_22 = {
  class: "iconContainer"
};

var _hoisted_23 = /*#__PURE__*/_withScopeId(function () {
  return /*#__PURE__*/_createElementVNode("span", {
    class: "text"
  }, "协作修谱", -1);
});

var _hoisted_24 = {
  class: "h-page"
};
var _hoisted_25 = {
  class: "h-right"
};
var _hoisted_26 = {
  class: "tree-box"
};
var _hoisted_27 = {
  class: "root"
};
var _hoisted_28 = {
  class: "info-box"
};
import { Search } from '@element-plus/icons-vue';
import PedigreeEdit from './pedigreeEdit';
import MyTree from './myTree';
import { useRoute } from 'vue-router';
import { ref } from 'vue';
import { getPedigreeDetail, savePedigreeDetail, removePedigreeDetail } from '@/api/pedigreeDetail';
import i18n from '@/i18n';
import { ElMessage, ElMessageBox } from 'element-plus';
import { rankPedigree, rankLevel } from '@/utils/filter.js';
export default {
  setup: function setup(__props) {
    var route = useRoute();
    var pedigreeId = ref(0);
    var pedigreeList = ref([]);
    var pedigreeData = ref();
    var input = ref();
    var pedigreeSurname = ref('');

    var initData = /*#__PURE__*/function () {
      var _ref = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
        var res;
        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                pedigreeId.value = route.query.id;
                _context.next = 3;
                return getPedigreeDetail(pedigreeId.value);

              case 3:
                res = _context.sent;
                res[0].lastItem = true;
                res[0].ranking = '始祖';
                pedigreeSurname.value = res[0].surname;

                if (res && res.length > 0) {
                  initList(res, 0);
                }

                pedigreeList.value = res;

              case 9:
              case "end":
                return _context.stop();
            }
          }
        }, _callee);
      }));

      return function initData() {
        return _ref.apply(this, arguments);
      };
    }();

    var num = 0;

    var initList = function initList(res, level) {
      res.forEach(function (item) {
        item.status = true;
        item.selected = false;

        if (item.ranking !== '始祖') {
          item.ranking = rankPedigree(item.sex, item.rankingId);
        }

        item.levelName = rankLevel(level);
        item.level = level; // 判断有没有 child

        if (item.child != null && item.child.length > 0) {
          item.childCount = item.child.length;

          if (num !== level) {
            num = level;
          }

          item.hasbranch = true;

          if (level < 3) {
            item.expand = true;
          } else {
            item.expand = false;
          }

          item.groupHead = 'group';
          item.child[item.child.length - 1].lastItem = true;
          initList(item.child, ++num);
        } else {
          item.hasbranch = false;
          item.groupHead = 'nullcList';
          item.lastItem = true;
        }
      });
    };

    initData();

    var triggerMenu = function triggerMenu(item) {
      selectedMenu(pedigreeList.value, item.id, item.parentId);
      pedigreeData.value = item;
    };

    var selectedMenu = function selectedMenu(menus, id, parentId) {
      if (id < 0) {
        menus.forEach(function (item) {
          if (item.id === parentId) {
            item.selected = true;
            pedigreeData.value = item;
          } else {
            item.selected = false;
          }

          if (item.id === id) {
            item.writing = true;
          } else {
            item.writing = false;
          }

          if (item.child && item.child.length > 0) {
            selectedMenu(item.child, id, parentId);
          }

          if (item.spouseList && item.spouseList.length > 0) {
            selectedMenu(item.spouseList, id, parentId);
          }
        });
      } else {
        menus.forEach(function (item) {
          if (item.id === id) {
            item.selected = true;
            pedigreeData.value = item;
            item.writing = false;

            if (item.child && item.child.length > 0) {
              item.child[item.child.length - 1].lastItem = false;
            }
          } else {
            item.selected = false;
            item.writing = false;

            if (item.child && item.child.length > 0) {
              item.child[item.child.length - 1].lastItem = true;
            }
          }

          if (item.child && item.child.length > 0) {
            selectedMenu(item.child, id, parentId);
          }

          if (item.spouseList && item.spouseList.length > 0) {
            selectedMenu(item.spouseList, id, parentId);
          }
        });
      }
    };

    var addNewNode = function addNewNode(type, id) {
      newNode(pedigreeList.value, type, id);
    };

    var newNode = function newNode(info, type, id) {
      switch (type) {
        case 0:
          info.forEach(function (item) {
            if (item.id === id) {
              item.selected = true;
              item.expand = true;
              var newChild = {
                id: Math.random() * -100,
                surname: item.surname,
                name: '',
                writing: true,
                sex: 0,
                selected: true,
                parentId: item.id,
                pedigreeId: item.pedigreeId,
                parentType: type,
                childCount: item.child == null ? 0 : item.child.length,
                level: item.level + 1,
                child: [],
                spouseList: []
              };
              item.child.push(newChild);
              input.value = newChild;
            }

            if (item.child && item.child.length > 0) {
              newNode(item.child, type, id);
            }
          });
          break;

        case 1:
          info.forEach(function (item) {
            if (item.id === id) {
              item.selected = true;
              var newChild = {
                id: Math.random() * -100,
                writing: true,
                sex: 0,
                selected: true,
                parentId: item.id,
                pedigreeId: item.pedigreeId,
                parentType: type,
                childCount: 0,
                level: item.level
              };
              item.spouseList.push(newChild);
              input.value = newChild;
            }

            if (item.child && item.child.length > 0) {
              newNode(item.child, type, id);
            }
          });
          break;

        case 2:
          info.forEach(function (item) {
            if (item.id === id) {
              item.selected = false;
              var newChild = {
                id: Math.random() * -100,
                surname: item.surname,
                name: '',
                writing: true,
                sex: 0,
                selected: true,
                parentId: item.id,
                pedigreeId: item.pedigreeId,
                parentType: type,
                childCount: item.child == null ? 0 : item.child.length,
                level: item.level + 1,
                child: [],
                spouseList: []
              };
              input.value = newChild;
              item.child.push(newChild);
            }

            if (item.child && item.child.length > 0) {
              newNode(item.child, type, id);
            }
          });
          break;
      }
    };

    var onTextChange = /*#__PURE__*/function () {
      var _ref2 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2(item) {
        var name, surname, name2, childCount, data, returnData;
        return regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                console.log(item);
                name = item.surname;
                surname = '';
                name2 = ''; // 如果是配偶，一个字符取家族姓，2个以上取第一个字符为姓

                if (item.parentType === 1 && name.length === 1) {
                  debugger;
                  surname = pedigreeSurname.value;
                  name2 = name;
                } else {
                  surname = name.substring(0, 1);
                  name2 = name.slice(1);
                }

                childCount = item.parentType === 1 ? item.spouseList == null ? 0 : item.spouseList.length : item.childCount == null ? 0 : item.childCount;

                if (!(name2.length > 0)) {
                  _context2.next = 18;
                  break;
                }

                data = {
                  parentType: item.parentType === 2 ? 0 : item.parentType,
                  parentId: item.parentId,
                  pedigreeId: item.pedigreeId,
                  id: 0,
                  name: name2,
                  surname: surname,
                  sex: item.parentType === 1 ? 1 : 0,
                  rankingId: childCount
                };
                _context2.next = 10;
                return savePedigreeDetail(data);

              case 10:
                returnData = _context2.sent;
                ElMessage({
                  message: i18n.global.t('message.updeteSuccess'),
                  grouping: true,
                  type: 'success'
                });
                pedigreeData.value = returnData;
                item.id = returnData.id;
                item.name = returnData.name;
                item.surname = returnData.surname;
                item.ranking = rankPedigree(item.parentType === 1 ? 1 : 0, childCount);
                item.levelName = rankLevel(item.level);

              case 18:
                item.selected = false;
                item.writing = false;
                item.lastItem = true;

              case 21:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2);
      }));

      return function onTextChange(_x) {
        return _ref2.apply(this, arguments);
      };
    }();

    var submit = function submit(item) {
      item.writing = false;
    };

    var changeExpand = function changeExpand(item) {
      item.expand = !item.expand;
    };

    var savePedigreeData = /*#__PURE__*/function () {
      var _ref3 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee3() {
        var res, editData, returnData;
        return regeneratorRuntime.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                res = pedigreeData.value;
                editData = {
                  id: res.id,
                  parentId: res.parentId,
                  parentType: res.parentType,
                  pedigreeId: res.pedigreeId,
                  surname: res.surname,
                  name: res.name,
                  aliasName: res.aliasName,
                  sex: res.sex,
                  title: res.title,
                  symbol: res.symbol,
                  rankingId: res.rankingId,
                  relationId: res.relationId,
                  statusId: res.statusId,
                  education: res.education,
                  company: res.company,
                  position: res.position,
                  birthday: res.birthday,
                  birthdayTime: res.birthdayTime,
                  address: res.address,
                  identity: res.identity,
                  death: res.death,
                  deathTime: res.deathTime,
                  burialAddress: res.burialAddress,
                  lifeCycle: res.lifeCycle,
                  introduction: res.introduction,
                  afterNote: res.afterNote,
                  afterIntroduction: res.afterIntroduction,
                  biography: res.biography,
                  content: res.content
                }; // JSON.parse(JSON.stringify(pedigreeData.value))

                _context3.next = 4;
                return savePedigreeDetail(editData);

              case 4:
                returnData = _context3.sent;
                ElMessage({
                  message: i18n.global.t('message.updeteSuccess'),
                  type: 'success'
                });
                selectedMenu(pedigreeList.value, returnData.id, 0);

              case 7:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee3);
      }));

      return function savePedigreeData() {
        return _ref3.apply(this, arguments);
      };
    }();

    var deletePedigreeDetail = function deletePedigreeDetail() {
      if (pedigreeData.value != null && pedigreeData.value.id > 0) {
        ElMessageBox.confirm("\u786E\u5B9A\u8981\u5220\u9664".concat(pedigreeData.value.surname).concat(pedigreeData.value.name, "\u5417?"), '删除', {
          confirmButtonText: '确认',
          cancelButtonText: '取消',
          type: 'warning'
        }).then( /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee4() {
          var id, parentType, parentId;
          return regeneratorRuntime.wrap(function _callee4$(_context4) {
            while (1) {
              switch (_context4.prev = _context4.next) {
                case 0:
                  id = pedigreeData.value.id;
                  parentType = pedigreeData.value.parentType;
                  parentId = pedigreeData.value.parentId;
                  _context4.next = 5;
                  return removePedigreeDetail(pedigreeId.value, pedigreeData.value.id);

                case 5:
                  ElMessage({
                    message: i18n.global.t('message.updeteSuccess'),
                    type: 'success'
                  });

                  if (parentType === 1) {
                    removeSpouse(pedigreeList.value, id);
                  } else {
                    selectedMenu(pedigreeList.value, parentId, 0);
                    removeChild(pedigreeList.value, id);
                  }

                case 7:
                case "end":
                  return _context4.stop();
              }
            }
          }, _callee4);
        }))).catch(function (e) {});
      }
    };

    var removeChild = function removeChild(list, id) {
      for (var i = 0; i < list.length; i++) {
        if (list[i].id === id) {
          list.splice(i, 1);
        }

        if (list[i].child && list[i].child.length > 0) {
          removeChild(list[i].child, id);
        }
      }
    };

    var removeSpouse = function removeSpouse(list, id) {
      for (var i = 0; i < list.length; i++) {
        for (var a = 0; a < list[i].spouseList.length; a++) {
          if (list[i].spouseList[a].id === id) {
            list[i].spouseList.splice(a, 1);

            if (a >= 1) {
              selectedMenu(pedigreeList.value, list[i].spouseList[a - 1].id, 0);
            } else {
              selectedMenu(pedigreeList.value, pedigreeData.value.parentId, 0);
            }
          }
        }

        if (list[i].child && list[i].child.length > 0) {
          removeSpouse(list[i].child, id);
        }
      }
    };

    return function (_ctx, _cache) {
      var _component_fold = _resolveComponent("fold");

      var _component_el_icon = _resolveComponent("el-icon");

      var _component_expand = _resolveComponent("expand");

      var _component_share = _resolveComponent("share");

      var _component_delete = _resolveComponent("delete");

      var _component_arrow_down = _resolveComponent("arrow-down");

      var _component_el_dropdown_item = _resolveComponent("el-dropdown-item");

      var _component_el_dropdown_menu = _resolveComponent("el-dropdown-menu");

      var _component_el_dropdown = _resolveComponent("el-dropdown");

      var _component_el_input = _resolveComponent("el-input");

      var _component_el_checkbox = _resolveComponent("el-checkbox");

      var _component_check = _resolveComponent("check");

      var _component_iphone = _resolveComponent("iphone");

      var _component_scale_to_original = _resolveComponent("scale-to-original");

      var _component_collection = _resolveComponent("collection");

      return _openBlock(), _createElementBlock(_Fragment, null, [_createElementVNode("div", _hoisted_1, [_createElementVNode("div", _hoisted_2, [_createVNode(_component_el_icon, {
        class: "icon"
      }, {
        default: _withCtx(function () {
          return [_createVNode(_component_fold)];
        }),
        _: 1
      }), _hoisted_3]), _createElementVNode("div", _hoisted_4, [_createVNode(_component_el_icon, {
        class: "icon"
      }, {
        default: _withCtx(function () {
          return [_createVNode(_component_expand)];
        }),
        _: 1
      }), _hoisted_5]), _createElementVNode("div", _hoisted_6, [_createVNode(_component_el_icon, {
        class: "icon"
      }, {
        default: _withCtx(function () {
          return [_createVNode(_component_share)];
        }),
        _: 1
      }), _hoisted_7]), _createElementVNode("div", {
        class: "iconContainer",
        onClick: deletePedigreeDetail
      }, [_createVNode(_component_el_icon, {
        class: "icon"
      }, {
        default: _withCtx(function () {
          return [_createVNode(_component_delete)];
        }),
        _: 1
      }), _hoisted_8]), _createVNode(_component_el_dropdown, null, {
        dropdown: _withCtx(function () {
          return [_createVNode(_component_el_dropdown_menu, null, {
            default: _withCtx(function () {
              return [_createVNode(_component_el_dropdown_item, null, {
                default: _withCtx(function () {
                  return [_hoisted_11];
                }),
                _: 1
              }), _createVNode(_component_el_dropdown_item, null, {
                default: _withCtx(function () {
                  return [_hoisted_12];
                }),
                _: 1
              }), _createVNode(_component_el_dropdown_item, null, {
                default: _withCtx(function () {
                  return [_hoisted_13];
                }),
                _: 1
              }), _createVNode(_component_el_dropdown_item, null, {
                default: _withCtx(function () {
                  return [_hoisted_14];
                }),
                _: 1
              }), _createVNode(_component_el_dropdown_item, null, {
                default: _withCtx(function () {
                  return [_hoisted_15];
                }),
                _: 1
              })];
            }),
            _: 1
          })];
        }),
        default: _withCtx(function () {
          return [_createElementVNode("span", _hoisted_9, [_hoisted_10, _createVNode(_component_el_icon, {
            class: "el-icon--right icon"
          }, {
            default: _withCtx(function () {
              return [_createVNode(_component_arrow_down)];
            }),
            _: 1
          })])];
        }),
        _: 1
      }), _createVNode(_component_el_input, {
        modelValue: _ctx.input2,
        "onUpdate:modelValue": _cache[0] || (_cache[0] = function ($event) {
          return _ctx.input2 = $event;
        }),
        class: "search",
        placeholder: "请输入要查找的内容",
        "suffix-icon": _unref(Search)
      }, null, 8, ["modelValue", "suffix-icon"]), _createVNode(_component_el_checkbox, {
        label: "显示姓",
        name: "type",
        checked: ""
      }), _createVNode(_component_el_checkbox, {
        label: "显示女性",
        name: "type",
        checked: ""
      }), _createVNode(_component_el_checkbox, {
        label: "显示排行",
        name: "type",
        checked: ""
      }), _createVNode(_component_el_checkbox, {
        label: "显示村庄",
        name: "type",
        checked: ""
      }), _createElementVNode("div", _hoisted_16, [_createElementVNode("div", {
        class: "iconContainer",
        onClick: savePedigreeData
      }, [_createVNode(_component_el_icon, {
        class: "icon"
      }, {
        default: _withCtx(function () {
          return [_createVNode(_component_check)];
        }),
        _: 1
      }), _hoisted_17]), _createElementVNode("div", _hoisted_18, [_createVNode(_component_el_icon, {
        class: "icon"
      }, {
        default: _withCtx(function () {
          return [_createVNode(_component_iphone)];
        }),
        _: 1
      }), _hoisted_19]), _createElementVNode("div", _hoisted_20, [_createVNode(_component_el_icon, {
        class: "icon"
      }, {
        default: _withCtx(function () {
          return [_createVNode(_component_scale_to_original)];
        }),
        _: 1
      }), _hoisted_21]), _createElementVNode("div", _hoisted_22, [_createVNode(_component_el_icon, {
        class: "icon"
      }, {
        default: _withCtx(function () {
          return [_createVNode(_component_collection)];
        }),
        _: 1
      }), _hoisted_23])])]), _createElementVNode("div", _hoisted_24, [_createElementVNode("div", _hoisted_25, [_createElementVNode("div", _hoisted_26, [_createElementVNode("div", _hoisted_27, [_createVNode(_unref(MyTree), {
        list: pedigreeList.value,
        input: input.value,
        onSubmit: submit,
        onTriggerMenu: triggerMenu,
        onAddNewNode: addNewNode,
        onOnTextChange: onTextChange,
        onChangeExpand: changeExpand,
        onDeletePedigreeDetail: deletePedigreeDetail
      }, null, 8, ["list", "input"])])]), _createElementVNode("div", _hoisted_28, [_createVNode(_unref(PedigreeEdit), {
        data: pedigreeData.value,
        onAddNewNode: addNewNode
      }, null, 8, ["data"])])])])], 64);
    };
  }
};